// What Gitcha Pro adds, worded once. The Gitcha Pro page and the plan card in
// the Pro modals both read it so the copy cannot drift between them.
export const PRO_INTRO = "Gitcha Pro adds three things to the bio buyers and agents see when they open your Buyer\u00a0Want\u2011Listings.";

export const PRO_FEATURES = [
  { title: "Buyer listing form", body: "Buyers send you their price, areas and timing from your bio." },
  { title: "Videos on your Buyer Want\u2011Listings", body: "Show agents the kind of home your buyer wants." },
  { title: "Branded share cards", body: "Your photo and logo on every card you post to social media." },
];
